export default {
  toggleMainLinkReverse: {
    border: data => '1px solid ' + data.mainColor,
    color: data => data.mainColor,
    boxSizing: 'content-box',
    textTransform: 'uppercase',
    cursor: 'pointer',
    textAlign: 'center',
    textDecoration: 'none',
    padding: '15px 0',
    width: '100%',
    '&:hover': {
      color: '#fff',
      backgroundColor: data => data.mainColor,
      WebkitTransition: '0.3s',
      OTransition: '0.3s',
      MsTransition: '0.3s',
      MozTransition: '0.3s',
      transition: '0.3s',
      textDecoration: 'none'
    }
  },
  searchOptionsHotelLink: {
    height: '50px',
    width: '100%',
    textAlign: 'center',
    font: data => '300 13px/1.38 ' + data.fontFamily1,
    position: 'relative',
    padding: '0 21px 0 10px',
    textDecoration: 'none',
    display: 'table-cell',
    verticalAlign: 'middle',
    '& span': {
      '& span': {
        font: '10px/1px Icons',
        position: 'absolute',
        top: '50%',
        right: '0',
        color: data => data.mainColor,
        '&:lang(ar)': {
          right: 'auto',
          left: '0',
        }
      }
    },
    '&:lang(ar)': {
      paddingRight: '10px',
      paddingLeft: '21px'
    },
    '&:hover': {
      textDecoration: 'none'
    },
  }
};
